export interface CharacterData {
	id: string;
	name: string;
	ruby: string;
	color: string;
	image: string;
	debut?: string;
	description?: string;
	tags?: string[];
}

export const CHARACTERS: CharacterData[] = [
	{
		id: "karoma",
		name: "カロマ",
		ruby: "Karoma",
		color: "#ffcccc",
		image: "/src-character/karoma/karoma.webp",
		debut:"2022年",
		description: "Adzuki.の代理キャラ兼であり、\n「躁のイマジア」のもう一人の主人公。\n\nかなりズボラらしく、暑がり。\n\nサン・ビレッジの中では一番長く住んでいるらしい。",
		tags:["躁のイマジア","代理","主人公","2.5頭身"],
	},

	{
		id:"kafuka",
		name:"カフカ",
		ruby:"Kafuka",
		color:"#eeb7f5",
		image:"/src-character/kafuka/kafuka.webp",
		debut:"2022年",
		description:"「躁のイマジア」の名目上の主人公。\n元人間。\n\nふわふわしていて、誰にでも丁寧に接する。\n\nよくカロマ達から「カフ」と呼ばれる。",
		tags:["躁のイマジア","主人公","元人間","2.5頭身"],
	},

	{
		id:"aramo",
		name:"アラモ",
		ruby:"Aramo",
		color:"#b3bb6a",
		image:"/src-character/aramo/aramo.webp",
		debut:"2023年",
		description:"「躁のイマジア」のキャラクター。\n警戒心が強い。でも情には厚い。\nかなり武闘派。",
		tags:["躁のイマジア","2.5頭身","武闘派"],

	},

	{
		id:"yorumi",
		name:"ヨルミ",
		ruby:"Yorumi",
		color:"#73bce0",
		image:"/src-character/yorumi/yorumi.webp",
		debut:"2024年",
		description:"「躁のイマジア」のキャラクター。\nコミュ障。気弱で怖がり。\nでも記憶力に優れている。",
		tags:["躁のイマジア","2.5頭身"],
	},

	{
		id:"chrol",
		name:"ちろる",
		ruby:"Chrol",
		color:"#e49ee0",
		image:"/src-character/chrol/chrol.png",
		debut:"2023年",
		description:"「シュガビタエブリデイズ」の主人公。\n元人間(♂)の女の子。\n内気。でも興味があるものには積極的。",
		tags:["シュガビタエブリデイズ","主人公","元人間","2頭身","女の子"],
	},
	{
		id:"supia",
		name:"すぴあ",
		ruby:"Supia",
		color:"#e2d7e2",
		image:"/src-character/supia/supia.png",
		debut:"2023年",
		description:"「シュガビタエブリデイズ」の登場人物。\nよく喋る男の子。\nとぼけているが、実はヤバい所もある。",
		tags:["シュガビタエブリデイズ","2頭身","男の子"],
	},
	{
		id:"ipuru",
		name:"いぷる",
		ruby:"Ipuru",
		color:"#ebb36b",
		image:"/src-character/ipuru/ipuru.png",
		debut:"2023年",
		description:"「シュガビタエブリデイズ」の登場人物。\n男の子。\nかなり臆病。でもグルメ。",
		tags:["シュガビタエブリデイズ","2頭身","男の子"],
	},

	{
		id:"siruku",
		name:"しるく",
		ruby:"Siruku",
		color:"#eb6bda",
		image:"/src-character/siruku/siruku.png",
		debut:"2024年",
		description:"「シュガビタエブリデイズ」の登場人物。\n街はずれのケーキ屋さんの店主。\n「髪のお告げ」の一部が使える。",
		tags:["シュガビタエブリデイズ","2頭身","女の子","元人間"],
	},

	{
		id:"yotuba",
		name:"よつば",
		ruby:"Yotuba",
		color:"#bedd94",
		image:"/src-character/yotuba/yotuba.png",
		debut:"2025年",
		description:"「シュガビタエブリデイズ」の登場人物。\n色々やって行方不明。\n我が強い。",
		tags:["シュガビタエブリデイズ","2頭身","女の子","元人間"],
	},

	{
		id:"nova",
		name:"プリンセス",
		ruby:"Princess",
		color:"#ebb36b",
		image:"/src-character/nova/nova.png",
		debut:"2023年",
		description:"「シュガビタエブリデイズ」の登場人物。\n色々謎。シュガビタ世界をどうこうする力を持っている。\n敵対さえしなければ多分大丈夫。知らんけど",
		tags:["シュガビタエブリデイズ","2.5頭身"],
	},

	// 他のキャラクターもここに追加
];
